import { useMutation } from '@tanstack/react-query';
import { gqlFetcher, type MutationOptions } from '../fetcher';
import { RequestResetMfaEmail } from '../mutations/requestResetMfaEmail.mutation';
import type { RequestResetMfaEmailMutation, RequestResetMfaEmailMutationVariables } from '../types';

export const useRequestResetMfaEmailMutation = (
  options?: MutationOptions<RequestResetMfaEmailMutation, RequestResetMfaEmailMutationVariables>,
) => {
  return useMutation(gqlFetcher(RequestResetMfaEmail), options);
};
